module.exports = __webpack_public_path__ + "static/img/4.8281bcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/4.png
// module id = JF4H
// module chunks = 0